import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s talk about your project</h2>
                        </div>
                        <p>TekRevol is here to bring your React Native app ideas to life. Share your project, whether it's a clear plan or just a spark. Our development services prioritize simplicity, effectiveness, and collaboration. We value your input to create a user-friendly and impactful React Native app. Ready to move forward? Fill out the form and click "Get In Touch" to start.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;